// import { useState } from "react";

// const slides = [
//   // {
//   //   image: "/1113.jpg",
//   //   // title: "Choose Best Sanitary\nNapkin for You",
//   //   // subtitle:
//   //   //   "Which baby napkin is right for you?\nThis can be a tough choice, but luckily we have all the information necessary.",
//   //   align: "left",
//   // },

//   {
//     image: "/1111.png",
//     // title: "Maintain Hygiene,\nThe Safest Sanitary Napkin",
//     // subtitle:
//     //   "Whether you're a Guardian or Adult looking for the best sanitary napkin, our online store has everything!",
//     // align: "left",
//   },
//   {
//     image: "/1112.png",
//     // title: "Sanitary Napkins\nwith a Difference",
//     // subtitle:
//     //   "With Sanitary Napkins with a Difference, you can feel confident and comfortable during your period.",
//     // align: "right", // 👈 ONLY THIS SLIDE
//   },
// ];

// export default function HeroSlider() {
//   const [index, setIndex] = useState(0);

//   const prev = () =>
//     setIndex((index - 1 + slides.length) % slides.length);

//   const next = () =>
//     setIndex((index + 1) % slides.length);

//   return (
//     <section
//       className="
//         relative
//         w-screen
//         left-1/2
//         -translate-x-1/2
//         overflow-hidden
//         bg-white
//             -mt-4 md:-mt-6
//       "
//     >
//       {/* SLIDER */}
//       <div
//         className="flex transition-transform duration-700 ease-in-out"
//         style={{ transform: `translateX(-${index * 100}%)` }}
//       >
//         {slides.map((slide, i) => (
//           <div
//             key={i}
//             className="
//               min-w-full
//               h-[260px]
//               sm:h-[380px]
//               md:h-[500px]
//               lg:h-[600px]
//               relative
//             "
//           >
//             {/* IMAGE */}
//             <img
//               src={slide.image}
//               alt={`slide-${i}`}
//               className="absolute inset-0 w-full h-full object-cover"
//             />

//             {/* TEXT OVERLAY (ONLY ADDITION) */}
//             <div
//               className="
//                 absolute inset-0 z-10
//                 flex items-center
//                 px-6 sm:px-10 md:px-20
//                 bg-black/20
//               "
//             >
//             <div
//   className={`max-w-xl text-white
//     ${slide.align === "right" ? "text-right ml-auto" : "text-left"}
//   `}
// >

//                 <h1
//                   className="
//                     whitespace-pre-line
//                     text-[22px]
//                     sm:text-[28px]
//                     md:text-[44px]
//                     font-medium
//                     leading-tight
//                     tracking-wide
//                   "
//                 >
//                   {slide.title}
//                 </h1>

//                 <p
//                   className="
//                     whitespace-pre-line
//                     mt-3 sm:mt-4
//                     text-[13px]
//                     sm:text-[14px]
//                     md:text-[16px]
//                     leading-relaxed
//                   "
//                 >
//                   {slide.subtitle}
//                 </p>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* LEFT ARROW */}
//       <button
//         onClick={prev}
//         className="absolute left-4 md:left-6 top-1/2 -translate-y-1/2
//                    w-9 h-9 md:w-10 md:h-10 rounded-full bg-black/40 text-white
//                    flex items-center justify-center hover:bg-black/60 z-20"
//       >
//         ‹
//       </button>

//       {/* RIGHT ARROW */}
//       <button
//         onClick={next}
//         className="absolute right-4 md:right-6 top-1/2 -translate-y-1/2
//                    w-9 h-9 md:w-10 md:h-10 rounded-full bg-black/40 text-white
//                    flex items-center justify-center hover:bg-black/60 z-20"
//       >
//         ›
//       </button>

//       {/* DOTS */}
//       <div className="absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 flex gap-2 md:gap-3 z-20">
//         {slides.map((_, i) => (
//           <button
//             key={i}
//             onClick={() => setIndex(i)}
//             className={`w-2.5 h-2.5 md:w-3 md:h-3 rounded-full transition ${
//               i === index ? "bg-gray-700" : "bg-gray-400"
//             }`}
//           />
//         ))}
//       </div>
//     </section>
//   );
// }
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const slides = [
  {
    bg: "/bg-soft.png",
    product: "/confidays_product.png",
    title: "Comfort You Can Trust,\nProtection You Deserve",
    subtitle:
      "Ultra-soft, skin-friendly sanitary napkins for everyday comfort and complete protection.",
  },

  {
    bg: "/bg-soft.png",
    product: "/confidays_product2.webp",
    title: "Gentle Care,\nPowerful Protection",
    subtitle:
      "Stay worry-free with skin-friendly sanitary napkins made for comfort and performance.",
  },
];

export default function HeroSlider() {
  const [index, setIndex] = useState(0);
const navigate = useNavigate();
  const prev = () => setIndex((index - 1 + slides.length) % slides.length);

  const next = () => setIndex((index + 1) % slides.length);

  return (
    <section
      className="
        relative
        w-screen
        left-1/2
        -translate-x-1/2
        overflow-hidden
        -mt-4 md:-mt-6
      "
    >
      {/* SLIDER */}
      <div
        className="
          flex
          transition-transform
          duration-700
          ease-in-out
        "
        style={{
          transform: `translateX(-${index * 100}%)`,
        }}
      >
        {slides.map((slide, i) => (
          <div
            key={i}
            className="
              min-w-full
              h-[720px]
              md:h-[680px]
              relative
              overflow-hidden
            "
          >
            {/* BACKGROUND IMAGE */}
            <img
              src={slide.bg}
              alt=""
              className="
                absolute
                inset-0
                w-full
                h-full
                object-cover
              "
            />

            {/* LIGHT OVERLAY FOR BETTER TEXT READABILITY */}
            <div
              className="
                absolute
                inset-0
                bg-white/10
                z-[1]
              "
            />

            {/* CONTENT */}
            <div
              className="
    relative
    z-10
    h-full
    max-w-7xl
    mx-auto

    px-6
    md:px-16

    flex
    flex-col-reverse
    md:flex-row

    items-center
    justify-center
    md:justify-between

    pt-10
    md:pt-0
  "
            >
              {/* LEFT TEXT */}
              <div
                className="
max-w-full md:max-w-2xl
                  text-left
                  relative
                  z-20
                "
              >
                {/* HEADING */}
                <h1
                  className="
    whitespace-pre-line
    font-cormorant
    italic
text-[40px]
sm:text-[52px]
md:text-[86px]
    sm:text-[58px]
    md:text-[86px]
    leading-[0.92]
    tracking-[-1.5px]
    text-brandPurple
    font-semibold
  "
                >
                  {slide.title}
                </h1>

                {/* SUBTITLE */}
                <p
                  className="
                    mt-6
                    font-poppins
                    text-[16px]
                    sm:text-[18px]
                    md:text-[22px]
                    text-[#4B5563]
                    leading-[1.9]
                    font-normal
                    max-w-[650px]
                  "
                >
                  {slide.subtitle}
                </p>

                {/* BUTTON */}
                <button

                  onClick={() =>
    navigate(
      "/products?page=1&limit=12&max_price=1000&sort=old"
    )
  }
                  className="
                    mt-10
                    px-10
                    py-4
                    rounded-full
                    bg-brandPink
                    hover:scale-105
                    hover:shadow-xl
                    text-white
                    text-lg
                    font-poppins
                    font-medium
                    transition-all
                    duration-300
                    mb-20
                    md:mb-0
                  "
                >
                  Shop Now
                </button>
              </div>

              {/* RIGHT IMAGE */}
              <div
                className="
    flex
    justify-center
    items-end

    w-full
    md:flex-1

    mt-6
    md:mt-0

    md:translate-x-28

    overflow-visible
    pointer-events-none
  "
              >
                <img
                  src={slide.product}
                  alt=""
                  className="
      h-[280px]
      sm:h-[360px]
      md:h-[100%]

      w-auto
      object-contain

      scale-[1.1]
      md:scale-[1.65]
    "
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* LEFT ARROW */}
      <button
        onClick={prev}
        className="
          absolute
          left-4
          md:left-6
          top-1/2
          -translate-y-1/2
          w-10
          h-10
          md:w-12
          md:h-12
          rounded-full
          bg-black/25
          backdrop-blur-sm
          text-white
          flex
          items-center
          justify-center
          hover:bg-black/40
          transition
          z-20
        "
      >
        ‹
      </button>

      {/* RIGHT ARROW */}
      <button
        onClick={next}
        className="
          absolute
          right-4
          md:right-6
          top-1/2
          -translate-y-1/2
          w-10
          h-10
          md:w-12
          md:h-12
          rounded-full
          bg-black/25
          backdrop-blur-sm
          text-white
          flex
          items-center
          justify-center
          hover:bg-black/40
          transition
          z-20
        "
      >
        ›
      </button>

      {/* DOTS */}
      <div
        className="
          absolute
          bottom-6
          left-1/2
          -translate-x-1/2
          flex
          gap-3
          z-20
      
        "
      >
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setIndex(i)}
            className={`
              w-3
              h-3
              
              rounded-full
              transition-all
              duration-300
              ${i === index ? "bg-brandPink scale-125" : "bg-gray-300"}
            `}
          />
        ))}
      </div>
    </section>
  );
}
